import { useRouter } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

export const AbortOnRouteChange = () => {
  const router = useRouter();
  const abortControllerRef = useRef(new AbortController());

  useEffect(() => {
    const unsubscribe = router.subscribe("onBeforeNavigate", () => {
      abortControllerRef.current.abort();
      abortControllerRef.current = new AbortController();
    });
    return () => unsubscribe();
  }, [router]);

  return null;
};
